module.exports = __webpack_public_path__ + "img/part-1-title.c3e8e951.png";